var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimReference.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Id } from './Id';
import { Version } from './Version';
import { ReferenceSource } from './SourceProps';
import { ApiDomain } from './domain';
import { BimModel, BimCategory, BimFamily, BimStandardSize, BimElement } from './BimEntity';
import { UserClassifier } from './UserClassifierRepo';
export var BimReference;

(function (_BimReference) {
  var domain = ApiDomain.domain('BimReference', {
    name: "domain",
    sid: "ti7oke"
  });
  var io = _BimReference.io = t.recursion('BimReference', function () {
    return t.union([Model.io, Category.io, Family.io, StandardSize.io, Element.io]);
  });
  var Data = t.type({
    id: Id,
    parentClassifierId: Id,
    parentClassifierVersion: Version,
    parentGroupId: t.union([t["null"], Id]),
    source: t.union([t["null"], ReferenceSource])
  }, 'BimReferenceData');

  var is = _BimReference.is = function (entity) {
    return Model.is(entity) || Category.is(entity) || Family.is(entity) || StandardSize.is(entity) || Element.is(entity);
  };

  var Model;

  (function (_Model) {
    var io = _Model.io = t.intersection([Data, t.type({
      type: t.literal('BimModelReference'),
      element: t.union([BimModel.io, BimModel.NotLoaded.io])
    })], 'BimModelReference');

    var is = _Model.is = function (entity) {
      return entity.type === 'BimModelReference';
    };
  })(Model || (Model = _BimReference.Model || (_BimReference.Model = {})));

  var Category;

  (function (_Category) {
    var io = _Category.io = t.intersection([Data, t.type({
      type: t.literal('BimCategoryReference'),
      element: BimCategory.io
    })], 'BimCategoryReference');

    var is = _Category.is = function (entity) {
      return entity.type === 'BimCategoryReference';
    };
  })(Category || (Category = _BimReference.Category || (_BimReference.Category = {})));

  var Family;

  (function (_Family) {
    var io = _Family.io = t.intersection([Data, t.type({
      type: t.literal('BimFamilyReference'),
      element: BimFamily.io
    })], 'BimFamilyReference');

    var is = _Family.is = function (entity) {
      return entity.type === 'BimFamilyReference';
    };
  })(Family || (Family = _BimReference.Family || (_BimReference.Family = {})));

  var StandardSize;

  (function (_StandardSize) {
    var io = _StandardSize.io = t.intersection([Data, t.type({
      type: t.literal('BimStandardSizeReference'),
      element: BimStandardSize.io
    })], 'BimStandardSizeReference');

    var is = _StandardSize.is = function (entity) {
      return entity.type === 'BimStandardSizeReference';
    };
  })(StandardSize || (StandardSize = _BimReference.StandardSize || (_BimReference.StandardSize = {})));

  var Element;

  (function (_Element) {
    var io = _Element.io = t.intersection([Data, t.type({
      type: t.literal('BimElementReference'),
      element: BimElement.io
    })], 'BimElementReference');

    var is = _Element.is = function (entity) {
      return entity.type === 'BimElementReference';
    };
  })(Element || (Element = _BimReference.Element || (_BimReference.Element = {})));

  var create = _BimReference.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: BimReference.io,
    getKey: ['classifierId', 'classifierVersion', 'groupId', 'modelElementId', 'modelElementType', 'sourceClassifierId', 'sourceClassifierVersion']
  });
  var createRefs = _BimReference.createRefs = ApiCallService.create({
    name: 'createRefs',
    parentDomain: domain,
    result: t.recursion('UserClassifier', function () {
      return UserClassifier.io;
    }),
    getKey: ['classifierId', 'classifierVersion', 'parentGroupId']
  });
  var move = _BimReference.move = ApiCallService.create({
    name: 'move',
    parentDomain: domain,
    result: BimReference.io,
    getKey: ['id']
  });
  var moveRefs = _BimReference.moveRefs = ApiCallService.create({
    name: 'moveRefs',
    parentDomain: domain,
    result: t.recursion('UserClassifier', function () {
      return UserClassifier.io;
    }),
    getKey: ['id', 'version']
  });
  var remove = _BimReference.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: BimReference.io,
    getKey: ['id']
  });
})(BimReference || (BimReference = {}));